/**
 * Created by baird on 2016/12/30.
 */
import {
    Layout
} from '../mutation';

export default {
    state: {
        isFixedMenu: true,
        isShowMenu: true,
        isShowTopBar:false
    },
    mutations: {
        [Layout.CHANGE_MENU_FIXED](state, val) {
            state.isFixedMenu = val;
            if (state.isFixedMenu) {
                $('body').addClass('toggled sw-toggled');
            } else {
                $('body').removeClass('toggled sw-toggled');
            }
        },
        [Layout.CHANGE_MENU_SHOW](state, val) {
            state.isShowMenu = val;
        },
        [Layout.CHANGE_TOP_BAR](state, val) {
            state.isShowTopBar = val;
        }
    },
    actions: {
        changeFixedMenu({
            commit
        }, val) {
            commit(Layout.CHANGE_MENU_FIXED, val);
        },
        changeMenuShow({
            commit
        }, val) {
            commit(Layout.CHANGE_MENU_SHOW, val);
        }
    },
    getters: {
        isFixedMenu: state => {
            return state.isFixedMenu;
        },
        isShowMenu: state => {
            return state.isShowMenu;
        },
        isShowTopBar:state =>{
            return state.isShowTopBar;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/layout.js